import React from 'react';
import { Box } from '@components/Box';
import { JoykitIcon } from '@components/JoykitIcon';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { OverWriteOverflowX, SliderWrapper, StyledText, ItemWrapper, SwiperButtonLeft, SwiperButtonRight } from './HorizontalSlider.styles';
import { ResponsiveValue } from 'styled-system';
import { Theme } from 'styled-system';

interface HorizontalSliderProps {
  title?: string;
  titlePadding?: ResponsiveValue<string | number, Theme>;
  items: {
    id: string;
    item: JSX.Element;
  }[];
  hideScrollbar?: boolean;
}

const LeftArrow: React.FC = () => {
  const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);
  return (
    <SwiperButtonLeft hide={isFirstItemVisible} onClick={() => scrollPrev()} justifyContent="center" alignItems="center">
      <JoykitIcon name="backChevron" color="neutra6" size={24} />
    </SwiperButtonLeft>
  );
};

const RightArrow: React.FC = () => {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);
  return (
    <SwiperButtonRight hide={isLastItemVisible} onClick={() => scrollNext()} justifyContent="center" alignItems="center">
      <JoykitIcon name="forwardChevron" color="neutra6" size={24} />
    </SwiperButtonRight>
  );
};

export const HorizontalSlider: React.FC<HorizontalSliderProps> = ({ title, items, titlePadding = [8, 9], hideScrollbar = false }) => {
  return (
    <SliderWrapper marginX="auto" hideScrollbar={hideScrollbar}>
      <OverWriteOverflowX />
      <Box paddingX={titlePadding}>
        <StyledText color="mono1" variant="sectionEyeBrow24" tagName="h2">
          {title}
        </StyledText>
      </Box>
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} transitionBehavior="smooth">
        {items.map(({ id, item }) => (
          <ItemWrapper key={`horizontal-scroll-${id}`} marginY={[5, 6]}>
            {item}
          </ItemWrapper>
        ))}
      </ScrollMenu>
    </SliderWrapper>
  );
};
